import React from "react";
import { useTranslation } from "react-i18next";
import InputCst from "@components/InputCst/InputCst";
import { WizardStepProps } from "@components/WizardCst/types";
import { DynamicGroupWizardData } from "../types";
import { FieldGrid, StepContainer } from "../../Wizard/components/StepLayout";

const DynGroupInfoStep: React.FC<WizardStepProps<DynamicGroupWizardData>> = ({
  data,
  setData,
  errors,
}) => {
  const { t } = useTranslation("group-wizard-v2");

  return (
    <StepContainer>
      <FieldGrid>
        <InputCst
          id="dyn-group-name"
          label={`${t("fields.groupName")}*`}
          value={data.name}
          onChange={(e: any) => setData({ name: e.target.value })}
          error={!!errors.name}
          errorMessage={errors.name ? t(`validation.${errors.name}`) : ""}
        />
        <InputCst
          id="dyn-group-description"
          label={t("fields.groupDescription")}
          value={data.description}
          onChange={(e: any) => setData({ description: e.target.value })}
        />
      </FieldGrid>
    </StepContainer>
  );
};

export default DynGroupInfoStep;
